import { Button, MenuDropdown, SearchBar } from '@/components/Common';
import { IconPosition } from '@/components/Common/TextField/TextField.types';
import { ListItem } from '@/components/Ui';
import plusIcon from '@/assets/icons/plus.svg';
import { MenuItem as PrimeMenuItem } from 'primereact/menuitem';

interface Highlight {
  _id: string;
  slug: string;
  term: string;
}

type HighlightsProps = {
  highlights: Highlight[] | undefined;
  searchHighlights: string;
  setSearchHighlights: (value: string) => void;
  menuItems: (id: string) => PrimeMenuItem[];
  openHighlightModal: () => void;
  className?: string;
};

const Highlights = ({
  highlights,
  searchHighlights,
  setSearchHighlights,
  menuItems,
  openHighlightModal,
  className,
}: HighlightsProps) => {
  return (
    <div className="w-full">
      <div className={`h-[710px] ${className}`}>
        <div className="flex items-center">
          <div className="w-full">
            <div className="flex justify-between items-center w-full mb-8">
              <h2 className="text-white text-xl font-semibold">Glossaire</h2>
              <Button
                title="Terme"
                className="w-[113.5px]"
                icon={<img src={plusIcon} alt="plusIcon" />}
                iconPosition={IconPosition.RIGHT}
                onClick={openHighlightModal}
              />
            </div>
            <SearchBar
              placeholder="Rechercher un terme"
              value={searchHighlights}
              handleChange={(e) => setSearchHighlights(e.target.value ?? '')}
              className="mb-5"
            />
            <div className="h-[600px] overflow-y-auto">
              {highlights?.map((highlight) => (
                <ListItem
                  key={highlight.slug}
                  listItemStyle="!bg-black !rounded-l-xl !border-l-[13px]"
                >
                  <div className="flex items-center justify-between">
                    <p>{highlight.term}</p>
                    <button>
                      <MenuDropdown
                        menuItems={menuItems(highlight._id)}
                        dotsStyle="bg-mikadoYellow"
                      />
                    </button>
                  </div>
                </ListItem>
              ))}
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Highlights;
